<div class="trading-minimum-container">
  <div class="trading-minimum-container-row">
    <div class="trading-minimum-container-element">
      <ng-template #tradingMinimumToolTipTemplateRef>

        <div>
          <div>
            <strong>Trade Minimums - Minimum Buy / Minimum Sell</strong>
            <p>Min Buy and Min Sell are your preferred minimum trade amounts for any identified trade of
              this security. For
              mutual funds, if you set both a dollar and a percent minimum, they will be compared to the
              applicable fund
            minimums, and the highest of these values will take precedence.</p>
            @if (formatSecurityType(this.securityType) === 'Mutual Fund') {
              <p>Fund imposed minimums are
                also considered and, if larger than your minimums, will take
              precedence.</p>
            }
          </div>
        </div>
      </ng-template>
      <ng-template #tradingMinimumAltToolTipTemplateRef>

        <div>
          <div style="margin-top:10px">
            <strong>Trade Minimum Alternate </strong>
            <p>The security specified here can be purchased as an alternate if this security's MinBuy amount
              (above) can't
            be met.</p>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="trading-minimum-container-row">
    <div class="trading-minimum-container-element">
      <div class="trading-minimum-element-label">Min Buy $</div>
      <div class="trading-minimum-element-input">
        <irb-number-text-box [(value)]="minBuyDollar"
          [max]="maxDollarValue"
          [min]="minDollarValue"
          [places]="0"
          [isCurrency]="true"
          [isRequired]="true"
          [placeholder]="minBuyDollarPlaceHolder"
          invalidMessage="Please enter only whole numbers."
          (change)="onMinBuyDollarChanged($event)"
        ></irb-number-text-box>
      </div>
    </div>
    <div class="trading-minimum-container-element">
      <div class="trading-minimum-element-label">Min Sell $</div>
      <div class="trading-minimum-element-input">
        <irb-number-text-box [(value)]="minSellDollar"
          [max]="maxDollarValue"
          [min]="minDollarValue"
          [places]="0"
          [isCurrency]="true"
          [isRequired]="true"
          [placeholder]="minSellDollarPlaceHolder"
          invalidMessage="Please enter only whole numbers."
          (change)="onMinSellDollarChanged($event)"
        ></irb-number-text-box>
      </div>
      <div class="trading-minimum-element-label trading-minimum-comp-header">
        <span class="infoIcon tradingMinimumCompToolTipIcon" calltoaction
        [calltoactionTemplate]="tradingMinimumToolTipTemplateRef"></span>
      </div>
    </div>
    <div class="trading-minimum-container-element trading-minimum-min-alt-dropdown">
      <div class="trading-minimum-element-label">Min Alt</div>
      <div class="trading-minimum-element-input">
        <irb-dropdown-search
          #alternativeSecuritiesDropdown
          [(value)]="selectedAltSecurity"
          (search)="getItemsForAlternativeSecuritiesDropdown($event)"
          (selection)="onAlternativeSecurityChanged($event)"
          (openNewItemFlow)="openNewItemSecurityFlow($event)"
          [addNewItem]="addNewSecurityItem"
          (clearSelection)="onAlternativeSecurityChanged({value: null})"
          size="30">
        </irb-dropdown-search>
      </div>
      <div class="trading-minimum-element-label trading-minimum-comp-header">
        <span class="infoIcon tradingMinimumCompToolTipIcon" calltoaction
        [calltoactionTemplate]="tradingMinimumAltToolTipTemplateRef"></span>
      </div>
    </div>
  </div>
  <div class="trading-minimum-container-row">
    <div class="trading-minimum-container-element">
      <div class="trading-minimum-element-label">Min Buy %</div>
      <div class="trading-minimum-element-input">
        <irb-number-text-box [(value)]="minBuyPercent"
          [places]="2"
          [min]="minDollarPercent"
          [max]="maxDollarPercent"
          [isPercentage]="true"
          [isRequired]="true"
          [placeholder]="minBuyPercentPlaceHolder"
          invalidMessage="The value entered is not valid."
          (change)="onMinBuyPercentChanged($event)"
        ></irb-number-text-box>
      </div>
    </div>
    <div class="trading-minimum-container-element">
      <div class="trading-minimum-element-label">Min Sell %</div>
      <div class="trading-minimum-element-input">
        <irb-number-text-box [(value)]="minSellPercent"
          [places]="2"
          [min]="minDollarPercent"
          [max]="maxDollarPercent"
          [isPercentage]="true"
          [isRequired]="true"
          [placeholder]="minSellPercentPlaceHolder"
          invalidMessage="The value entered is not valid."
          (change)="onMinSellPercentChanged($event)"
        ></irb-number-text-box>
      </div>
    </div>
  </div>
  @if (_tradingMinimumData && !editModel
    && !_tradingMinimumData?.multipleSecurity
    && this.securityType && formatSecurityType(this.securityType) === 'Mutual Fund') {
    <section id="trading-minimum-override-values">
      <div class="trading-minimum-horizontal-ruler"></div>
      <div class="trading-minimum-container-row trading-override-Values">
        <div class="trading-minimum-container-element">
          <div class="trading-minimum-element-label trading-minimum-override-values-checkbox">
            <p-checkbox name="overrideValues" [(ngModel)]="overrideValues"
            binary="true" (onChange)="onOverrideValuesChanged($event)" inputId="tmitem1"></p-checkbox>
            <label for="tmitem1">Override Values</label>
            <span id="overrideValuesToolTipIcon" class="infoIcon" calltoaction
            [calltoactionTemplate]="overrideValuesTemplate"></span>
            <ng-template #overrideValuesTemplate>
              <div>
                You can override these fund imposed buy minimums by checking the checkbox. This is typically
                done if the fund family has made a concession for your firm. When overridden, iRebal will
                only consider the MinBuy and MinSell that you specify for this security.
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      @if (!overrideValues) {
        <div class="trading-override-table-container">
          <div class="block">Fund-imposed minimums for {{ _tradingMinimumData?.securityData[0]?.securityDescription}}</div>
          <table class="basic-table">
            <tr>
              <td class="gray">Initial Purchase:</td>
              <td class="bold alignRight">{{_tradingMinimumData?.securityData[0]?.initialPurchase  | number: undefined: 'en-US'}}</td>
            </tr>
          </table>
        </div>
      } @else {
        <div>
          You have chosen to override and ignore the minimums imposed by the fund. To use the fund
          imposed minimums, uncheck the override checkbox.
        </div>
      }
    </section>
  }
</div>

